import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import WMICLogoutPage from './pages/WMICLogoutPage/WMICLogoutPage';


setComponentMapOverrides(
    {
        WMICLogoutPage: { component: 'WMICLogoutPage' }
    },
    {
        WMICLogoutPage
    }
);

export { default as WMICLogoutPage } from './pages/WMICLogoutPage/WMICLogoutPage';
